export const style = {
	mainBgColor:'#2E2E38',
	mainTextColor:'#fff'
	
}